module.exports = __webpack_public_path__ + "static/img/20221222094843369.bdcbd01.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/index/20221222094843369.jpg
// module id = NNzh
// module chunks = 30